import React from 'react';
import PropTypes from 'prop-types';

import './ImagePreview.scss';

export const ImagePreview = ({ dataUri, isFullscreen }) => {
  const classNameFullscreen = isFullscreen ? 'image-preview--fullscreen' : '';

  return (
    <div className={`image-preview ${classNameFullscreen}`}>
      <img src={dataUri} alt="" />
    </div>
  );
};

ImagePreview.propTypes = {
  /** image source */
  dataUri: PropTypes.string,
  /** is Camera in fullscreen */
  isFullscreen: PropTypes.bool,
};

export default ImagePreview;
